import BaseState from '@state/BaseState'
import GameStatesEnum from "../GameStatesEnum";
import { Signals} from "@/Imports";


export default class BonusState extends BaseState {
  begin() {
    Signals.bonusGame.dispatch()
    Signals.bonusGameComplete.addOnce(this.end, this)
  }

  end = () => {
    this.model.isBonusStarted = false
    let gameState = GameStatesEnum.FINAL
    this.stateMachine.setState(gameState)
  }

  cleanUp() {
    Signals.bonusGameComplete.remove(this.end, this)
  }
}
